import React from 'react'

export interface MetaValueProps {
  children: React.ReactNode
  style?: React.CSSProperties
}

/**
 * Small, right-aligned secondary value — an ownership %, a region allocation %,
 * a short status label. One treatment so these read identically wherever they
 * sit alongside a primary label.
 */
export function MetaValue({ children, style }: MetaValueProps) {
  return (
    <span
      style={{
        fontFamily: 'var(--font-body)',
        fontSize: 'var(--text-body-sm)',
        fontWeight: 'var(--weight-semibold)',
        color: 'var(--color-text-secondary)',
        ...style,
      }}
    >
      {children}
    </span>
  )
}
